import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { AuthCallback } from './AuthCallback';
import { Hub } from './Hub';
import { Tournaments } from './Tournaments';
import { TournamentDetail } from './TournamentDetail';
import { WatchParty } from './WatchParty';
import { MatchDetail } from './MatchDetail';
import { TeamDetail } from './TeamDetail';
import { ChatList } from './ChatList';
import { ChatRoom } from './ChatRoom';
import { Profile } from './Profile';
import { UserProfile } from './UserProfile';
import { Leaderboards } from './Leaderboards';
import { LeaderboardDetail } from './LeaderboardDetail';
import { News } from './News';
import { ArticleDetail } from './ArticleDetail';
import { Avatars } from './Avatars';
import { AvatarCreate } from './AvatarCreate';
import { AvatarDetail } from './AvatarDetail';
import { AvatarEdit } from './AvatarEdit';
import { AvatarSeries } from './AvatarSeries';
import { AvatarClipDetail } from './AvatarClipDetail';
import { AvatarEditor } from './avatar-editor/AvatarEditor';
import { Riot } from './Riot';
import { RiotLolDetail } from './RiotLolDetail';
import { CRHome } from './cr/CRHome';
import { CRLink } from './cr/CRLink';
import { CRSavedDecks } from './cr/CRSavedDecks';
import { CRPopularDecks } from './cr/CRPopularDecks';
import { CRBattles } from './cr/CRBattles';
import { CRDeckCheck } from './cr/CRDeckCheck';
import { CRCoach } from './cr/CRCoach';
import { CRDeckBuilder } from './cr/CRDeckBuilder';
import { Settings } from './Settings';

export const router = createBrowserRouter([
  // Public route: must NOT be wrapped in AppShell (no auth gating, no TabBar)
  // — AppShell would loop the user back to <Login /> before the OIDC code is
  // exchanged for tokens.
  { path: '/auth/callback', element: <AuthCallback /> },

  // Avatar Editor wizard runs full-screen — bypass AppShell so the TabBar
  // doesn't intercept clicks on the sticky footer Next/Back buttons.
  { path: '/avatars/editor', element: <AvatarEditor /> },

  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Hub /> },

      { path: 'tournaments', element: <Tournaments /> },
      { path: 'tournaments/:id', element: <TournamentDetail /> },
      { path: 'tournaments/:id/watch-party', element: <WatchParty /> },

      { path: 'matches/:id', element: <MatchDetail /> },
      { path: 'teams/:id', element: <TeamDetail /> },

      { path: 'chat', element: <ChatList /> },
      { path: 'chat/:id', element: <ChatRoom /> },

      { path: 'profile', element: <Profile /> },
      { path: 'profile/:id', element: <UserProfile /> },

      { path: 'leaderboards', element: <Leaderboards /> },
      { path: 'leaderboards/:id', element: <LeaderboardDetail /> },

      { path: 'news', element: <News /> },
      { path: 'news/:slug', element: <ArticleDetail /> },

      { path: 'avatars', element: <Avatars /> },
      { path: 'avatars/new', element: <AvatarCreate /> },
      { path: 'avatars/:id', element: <AvatarDetail /> },
      { path: 'avatars/:id/edit', element: <AvatarEdit /> },
      { path: 'avatars/:id/series', element: <AvatarSeries /> },
      { path: 'avatars/:id/clips/:clipId', element: <AvatarClipDetail /> },

      { path: 'riot', element: <Riot /> },
      { path: 'riot/lol/:puuid', element: <RiotLolDetail /> },

      { path: 'cr', element: <CRHome /> },
      { path: 'cr/link', element: <CRLink /> },
      { path: 'cr/decks/saved', element: <CRSavedDecks /> },
      { path: 'cr/decks/popular', element: <CRPopularDecks /> },
      { path: 'cr/decks/check', element: <CRDeckCheck /> },
      { path: 'cr/decks/builder', element: <CRDeckBuilder /> },
      { path: 'cr/battles', element: <CRBattles /> },
      { path: 'cr/coach', element: <CRCoach /> },

      { path: 'settings', element: <Settings /> },

      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
